import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import DateInput from '../../../components/form/formInputs/DateInput/DateInput';
import { LoadingButton } from '@mui/lab';
import useAcquisitionOptionsModal from './hooks/useAcquisitionOptionsModal';
import { FA_Asset } from '../../../types/FixedAsset.types';
import { validateDateRange } from '../../../utils/comparisonUtils';

export interface ReportAcquisitionProps {
    open: boolean;
    onAcquisitionsLoaded: (contracts: FA_Asset[]) => void;
    onClose: () => void;
}

const AcquisitionOptionsModal = (props: ReportAcquisitionProps) => {
    const {
        fields,
        handleFieldChange,
        handleGetAcquisitions,
        isLoadingAcquisitions,
    } = useAcquisitionOptionsModal(props);

    return (
        <Dialog
            onClose={props.onClose}
            open={props.open}
            fullWidth
            maxWidth={'sm'}>
            <DialogTitle>
                <Box display="flex" alignItems="center">
                    <Box flexGrow={1}>Acquisition Options</Box>
                    <Box>
                        <IconButton onClick={props.onClose}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <DateInput
                            label="Acquire Date Begin"
                            id="acquireBeginDate"
                            value={fields.acquireBeginDate}
                            onChange={handleFieldChange}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <DateInput
                            label="Acquire Date End"
                            id="acquireEndDate"
                            value={fields.acquireEndDate}
                            onChange={handleFieldChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <LoadingButton
                            fullWidth
                            variant="contained"
                            type="submit"
                            disabled={
                                !validateDateRange(
                                    fields.acquireBeginDate,
                                    fields.acquireEndDate,
                                    true
                                )
                            }
                            loading={isLoadingAcquisitions}
                            onClick={handleGetAcquisitions}>
                            Get Acquisitions
                        </LoadingButton>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default AcquisitionOptionsModal;
